export default __webpack_public_path__ + "static/media/H1007.313388fa.mp3";